var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReserved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 27,
    rx: 8,
    fill: "currentColor",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6C9.67 6 9 6.67 9 7.5V20.25C9 20.53 9.16 20.79 9.42 20.91C9.68 21.03 9.98 20.99 10.2 20.81L14 17.9L17.8 20.81C18.02 20.99 18.32 21.03 18.58 20.91C18.84 20.79 19 20.53 19 20.25V7.5C19 6.67 18.33 6 17.5 6H10.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReserved);
export default __webpack_public_path__ + "static/media/reserved.fbae1d0376720d9de6162f0e406cca1f.svg";
export { ForwardRef as ReactComponent };